import React, { useMemo } from 'react';

import { ReactComponent as UserIcon } from '../../icons/user.svg';

import './profile-image.scss';

import { getColorPairFromInitials, getInitials } from '../../utils/tools';
import { Image } from '../common/image/Image';

export const ProfileImage = ({ width, height, profile, loading = false }) => {
  const initials = useMemo(() => getInitials(profile?.name), [profile]);
  const color = useMemo(() => getColorPairFromInitials(profile?.name), [profile]);

  if (!!profile && !profile?.imageUrl) {
    return (
      <div className="profile-image" style={{ width, height, background: color.light }}>
        <span style={{ color: color.dark }}>{initials}</span>
      </div>
    );
  }

  return (
    <Image
      width={width}
      height={height}
      alt={profile?.name}
      src={profile?.imageUrl}
      icon={<UserIcon />}
      loading={loading}
    />
  );
};
